const BoldIcon = ({ isActive, onClick }) => (
  <svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
  >
    <path
      d="M10.1566 7.62724C10.9548 7.07592 11.5143 6.17078 11.5143 5.33147C11.5143 3.47181 10.0743 2.04004 8.22287 2.04004H3.08002V13.56H8.87293C10.5927 13.56 11.9257 12.1612 11.9257 10.4414C11.9257 9.19067 11.2181 8.12095 10.1566 7.62724ZM5.54859 4.09718H8.01716C8.70013 4.09718 9.25145 4.6485 9.25145 5.33147C9.25145 6.01444 8.70013 6.56575 8.01716 6.56575H5.54859V4.09718ZM8.42859 11.5029H5.54859V9.03433H8.42859C9.11156 9.03433 9.66287 9.58564 9.66287 10.2686C9.66287 10.9516 9.11156 11.5029 8.42859 11.5029Z"
      fill={isActive ? 'white' : '#676879'}
    />
  </svg>
);

const ItalicsIcon = ({ isActive, onClick }) => (
  <svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
  >
    <path
      d="M5.65147 2.04004V4.50861H7.46999L4.65582 11.0915H2.36005V13.56H8.9429V11.0915H7.12439L9.93856 4.50861H12.2343V2.04004H5.65147Z"
      fill={isActive ? 'white' : '#676879'}
    />
  </svg>
);

const LeftAlignIcon = ({ isActive, onClick }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
  >
    <path
      d="M13.56 4.40039H2.76001"
      stroke={isActive ? 'white' : '#676879'}
      strokeWidth="1.44"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.16 8.00049H2.95996"
      stroke={isActive ? 'white' : '#676879'}
      strokeWidth="1.44"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.36 11.6001H2.95996"
      stroke={isActive ? 'white' : '#676879'}
      strokeWidth="1.44"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CenterAlignIcon = ({ isActive, onClick }) => (
  <svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
  >
    <path
      d="M13.16 4.40039H2.35999"
      stroke={isActive ? 'white' : '#676879'}
      strokeWidth="1.44"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 8.00049H3.79999"
      stroke={isActive ? 'white' : '#676879'}
      strokeWidth="1.44"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.16 11.6001H2.35999"
      stroke={isActive ? 'white' : '#676879'}
      strokeWidth="1.44"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const RightAlignIcon = ({ isActive, onClick }) => (
  <svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
  >
    <path
      d="M12.76 4.40039H1.96002"
      stroke={isActive ? 'white' : '#676879'}
      strokeWidth="1.44"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.96 8.00049H5.76001"
      stroke={isActive ? 'white' : '#676879'}
      strokeWidth="1.44"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.72 11.6001H4.32001"
      stroke={isActive ? 'white' : '#676879'}
      strokeWidth="1.44"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const FontMinusIcon = ({ color = '#676879', onClick }) => (
  <svg
    width="8"
    height="2"
    viewBox="0 0 8 2"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.400024 0.999961C0.400024 0.701727 0.641791 0.459961 0.940024 0.459961H6.70002C6.99826 0.459961 7.24002 0.701727 7.24002 0.999961C7.24002 1.29819 6.99826 1.53996 6.70002 1.53996H0.940024C0.641791 1.53996 0.400024 1.29819 0.400024 0.999961Z"
      fill={color}
    />
  </svg>
);

const FontPlusIcon = ({ color = '#676879', onClick }) => (
  <svg
    width="8"
    height="8"
    viewBox="0 0 8 8"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.11996 6.88008C3.11996 7.17831 3.36173 7.42008 3.65996 7.42008C3.9582 7.42008 4.19996 7.17831 4.19996 6.88008V4.54052H6.54005C6.83829 4.54052 7.08005 4.29875 7.08005 4.00052C7.08005 3.70229 6.83829 3.46052 6.54005 3.46052H4.19996V1.12008C4.19996 0.821844 3.9582 0.580078 3.65996 0.580078C3.36173 0.580078 3.11996 0.821844 3.11996 1.12008V3.46052H0.780051C0.481818 3.46052 0.240051 3.70229 0.240051 4.00052C0.240051 4.29875 0.481818 4.54052 0.780051 4.54052H3.11996V6.88008Z"
      fill={color}
    />
  </svg>
);

const DeleteIcon = ({ color = '#D83A52', onClick }) => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.67046 0C3.35572 0 3.06314 0.136176 2.85425 0.36306C2.64665 0.588556 2.53638 0.886177 2.53638 1.18872V1.37743H1.76819H0.5C0.223858 1.37743 0 1.60129 0 1.87743C0 2.15358 0.223858 2.37743 0.5 2.37743H1.26819V8.07593C1.26819 8.37847 1.37846 8.67609 1.58607 8.90159C1.79495 9.12847 2.08753 9.26465 2.40228 9.26465H6.84088C7.15562 9.26465 7.4482 9.12847 7.65709 8.90159C7.8647 8.6761 7.97497 8.37848 7.97497 8.07593V2.37743H8.74312C9.01927 2.37743 9.24312 2.15358 9.24312 1.87743C9.24312 1.60129 9.01927 1.37743 8.74312 1.37743H7.47497H6.70681V1.18872C6.70681 0.886177 6.59654 0.588556 6.38893 0.36306C6.18005 0.136176 5.88746 0 5.57272 0H3.67046ZM3.03303 2.37743C3.03414 2.37744 3.03526 2.37744 3.03638 2.37744H6.20681C6.20793 2.37744 6.20904 2.37744 6.21016 2.37743H6.97497V8.07593C6.97497 8.1387 6.95163 8.19144 6.9214 8.22427C6.89246 8.2557 6.86248 8.26465 6.84088 8.26465H2.40228C2.38068 8.26465 2.35069 8.2557 2.32175 8.22427C2.29153 8.19144 2.26819 8.1387 2.26819 8.07593V2.37743H3.03303ZM5.70681 1.37743V1.18872C5.70681 1.12595 5.68347 1.07321 5.65325 1.04038C5.6243 1.00895 5.59432 1 5.57272 1H3.67046C3.64886 1 3.61888 1.00895 3.58994 1.04038C3.55972 1.07321 3.53638 1.12595 3.53638 1.18872V1.37743H5.70681Z"
      fill={color}
    />
  </svg>
);

const ColorPickerIcon = ({ color = '#676879', onClick }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    onClick={onClick}
  >
    <path
      d="M7.4673 5.17727L7.611 5.02431C7.86593 4.7601 7.87057 4.44954 7.60636 4.18534L7.47657 4.05555C8.21357 3.40662 9.01083 3.34173 9.52997 2.81795C10.2484 2.09023 10.063 1.04267 9.51143 0.486449C8.96447 -0.0697749 7.91692 -0.241277 7.17992 0.467908C6.65151 0.982415 6.59125 1.7843 5.94232 2.5213L5.81717 2.39152C5.55297 2.12731 5.23777 2.13658 4.97357 2.38688L4.82061 2.53057C4.51005 2.82259 4.5564 3.1007 4.83451 3.37418L5.01992 3.56422L1.62695 6.95719C0.134421 8.45436 0.727726 8.42191 0 9.43238L0.477425 9.93298C1.45545 9.20989 1.51107 9.86345 3.01751 8.36629L6.43366 4.97332L6.6237 5.16336C6.90181 5.43684 7.17065 5.48319 7.4673 5.17727ZM1.56206 8.45899C1.4091 8.29212 1.43691 8.13453 1.60841 7.96302L5.50662 4.04628L5.96086 4.50517L2.04876 8.41727C1.8958 8.57023 1.70575 8.61659 1.56206 8.45899Z"
      fill={color}
    />
  </svg>
);

const PencilIcon = ({ color = '#676879', onClick }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    onClick={onClick}
  >
    <path
      d="M6.92708 1.79781C6.92705 1.79784 6.92711 1.79778 6.92708 1.79781L2.40458 6.32514L1.90682 8.09448L3.67841 7.59786L8.2009 3.07C8.23732 3.03361 8.25807 2.98397 8.25807 2.93251C8.25807 2.88111 8.23765 2.8318 8.20129 2.79542C8.20125 2.79538 8.20132 2.79545 8.20129 2.79542L7.20188 1.79784C7.16544 1.76146 7.11599 1.74099 7.06446 1.74099C7.01298 1.74099 6.96351 1.76148 6.92708 1.79781ZM6.40254 1.27377C6.57811 1.09848 6.81621 1 7.06446 1C7.31271 1 7.55079 1.09846 7.72635 1.27374C7.72634 1.27373 7.72636 1.27375 7.72635 1.27374L8.72577 2.27132C8.90128 2.44666 9 2.68457 9 2.93251C9 3.18046 8.9014 3.41825 8.72588 3.5936L4.13497 8.18997C4.08992 8.23507 4.03399 8.26781 3.97258 8.28502L1.47122 8.98621C1.34209 9.0224 1.20345 8.98617 1.10863 8.89144C1.0138 8.79671 0.977559 8.65824 1.01384 8.52928L1.71648 6.03166C1.73364 5.97066 1.76618 5.91507 1.811 5.87021L6.40254 1.27377Z"
      fill={color}
    />
  </svg>
);

export {
  DeleteIcon,
  FontMinusIcon,
  FontPlusIcon,
  RightAlignIcon,
  CenterAlignIcon,
  LeftAlignIcon,
  ItalicsIcon,
  BoldIcon,
  ColorPickerIcon,
  PencilIcon,
};
